// extracted by mini-css-extract-plugin
export default {"wrapper":"look-for-us_wrapper__AuQLr","image":"look-for-us_image__qjoQ+","link":"look-for-us_link__Unt1b","lookForUsWording":"look-for-us_lookForUsWording__vwfU8"};